import React, {Component} from 'react';
import { arrayMove } from 'react-sortable-hoc';
import axios from 'axios';
import PropTypes from 'prop-types';
import AppConstant from '../../../../constants/app';
import SortableList from './sectionsSortable/sortableList';

class SectionsSortable extends Component {
  static propTypes = {
    sectionsList: PropTypes.array,
  };

  static defaultProps = {
    sectionsList: [],
  };

  state = {
    isLoaderOpened: false,
  };

  onSortEnd = ({oldIndex, newIndex}) => {
    const {
      onChangeSectionsList,
      sectionsList,
    } = this.props;

    this.setState({ isLoaderOpened: true });

    const items = arrayMove(sectionsList, oldIndex, newIndex);
    
    axios({
      method: 'post',
      url: `${AppConstant.API_URL}/section/positions/update?access_token=${localStorage.getItem('token')}`, 
      data: {
        sections: items.map((item, index) => ({
          id: item.id,
          position: index + 1,
        }))
      },
    })
    .then(res => {
      const items = res.data.sections;
      onChangeSectionsList(items);
      this.setState({ isLoaderOpened: false });
    }).catch(err => {
      console.log(err);
    });
  };

  render() {
    const {
      sectionsList,
      showModalHandle,
    } = this.props;

    const {
      isLoaderOpened,
    } = this.state;

    return (
      <div>
        {
          isLoaderOpened
          ? <p> Loading... </p>
          : <SortableList
            items={sectionsList}
            onSortEnd={this.onSortEnd}
            pressDelay={200}
            showModalHandle={showModalHandle}
          />
        }
      </div>
    );
  }
}

export default SectionsSortable;


// WEBPACK FOOTER //
// ./src/app/screens/sections/sectionsList/sectionsSortable.js